<template>
    <center>
      <div id="about_card">
        <div style="width: 95%;">
        <h1 class="text-titlecolor">A fight against cybercrime</h1>
        <p style="font-size: 16px;">Protect yourself from online threats by tracking and securing your personal information on the Internet.</p>
      </div>
        <br><br>
        <v-card id="transparent" style="text-align: left;">
          <v-card-title class="text-textcolor">Who are we ?</v-card-title>
          <v-card-item>
            <p >
Hello everyone, I am 17 years old and I have been passionate about computers for several years. 
I chose to create this website to fight against cybercrime because nowadays cybercrimes are really common. So XSINT allows you to see the traces that we leave on the internet, 
this can be information such as usernames, photos, the sites on which we are registered and other information so that you can protect yourself better. This site also allows you to see 
if your email address has already been hacked and the information related to these hacks (ip addresses, passwords...)
          </p>
          </v-card-item>
        <v-card-item>
          <h3 class="text-textcolor">How to contact us ?</h3>
        </v-card-item>
        <v-card-item>
          <p>If you have any questions or feedback about the site, do not hesitate to contact us at the following email address:</p>
          <p><u>contact@xsint-intelligence.com</u></p>
        </v-card-item>

        </v-card>
      </div>
    </center>
</template>
<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'About Us | XSINT Intelligence',
  meta: [  
    { name: 'keywords', content: 'About us, about, informations, XSINT, XSINT Intelligence, xsint' },
    
    { property: 'og:title', content: 'About Us | XSINT Intelligence' },
    { name: 'twitter:title', content: 'About Us | XSINT Intelligence' },

    { name: 'description', content: 'Protect yourself from online threats by tracking and securing your personal information on the Internet.' },
    { property: 'og:description', content: 'Protect yourself from online threats by tracking and securing your personal information on the Internet.' },
    { name: 'twitter:description', content: 'Protect yourself from online threats by tracking and securing your personal information on the Internet.' },

    { property: 'og:type', content: 'website' },
    { name: 'robots', content: 'index, follow' },
    { property: 'og:url', content: 'https://www.xsint-intelligence.com/about-us' },
  ]
});
</script>
<style>

#transparent{
  background-color: transparent !important;
  box-shadow: none !important;
}

#about_card {
  margin-top: 90px;
  width: 100%;
  font-size: 18px;
}

#logo {
  width: 30%;
}

@media only screen and (min-width: 600px) {
  #about_card {
    width: 50%;
  }
  #logo {
    width: 10%;
  }
}

</style>
